//
// Module for the Retirement Setup wizard's Eligibility step
//
rs.module("participant/benefit/setup/retirement/wizard/eligibilitystep",

    ["controls/components/event-banner"],

    function (eventBanner) {

        // Initialize the module
        function initialize(jsSelectors, variables, backendUrls) {

            // get JS selectors
            var stepContainer = $.js(jsSelectors.stepContainer);
            var benefitTypeSelect = stepContainer.js(jsSelectors.benefitTypeSelect);
            var loadingSpinner = stepContainer.js(jsSelectors.loadingSpinner);
            var stepDetailContainer = stepContainer.js(jsSelectors.stepDetailContainer);

            // Reload the payment options for recalcs due to option limiting for recalcs
            if (variables.isRecalc) {
                benefitTypeChange(true);
            }

            // Hookup benefitTypeSelect change event
            benefitTypeSelect.change(function () {
                benefitTypeChange(false);
            });

            // Benefit Type change event
            function benefitTypeChange(isInitialize) {

                loadingSpinner.show();

                // Get selected Benefit Type
                var selectedBenefitType = benefitTypeSelect.val();

                // clear any messages in the message banner
                // we can't do this on initialize, otherwise we never see business messages!
                if (!isInitialize) {
                    eventBanner.removeAllMessages();
                }

                // Replace step detail content
                $.get(backendUrls.getEligibilityStepDetail,
                    {
                        benefitClaimPaymentKey: variables.benefitClaimPaymentKey,
                        benefitType: selectedBenefitType,
                        isRecalc: variables.isRecalc
                    })
                    .done(function (html) {
                        stepDetailContainer.html(html);
                    })
                    .always(function () {
                        loadingSpinner.hide();
                    });
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);